module.exports = __webpack_public_path__ + "img/team3.112133c8.webp";